// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.controller-header .btn-send {
  background: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  padding: 0.5rem 0;
  margin-left: auto;
}
.controller-header .btn-send img, .controller-header .btn-send svg {
  width: 1rem;
  height: 1rem;
}
.controller-header .btn-send:not(:disabled):hover img, .controller-header .btn-send:not(:disabled):hover svg {
  transition: all 1s ease-in-out;
  animation: flying linear 1s infinite normal;
  cursor: pointer;
}

.button-controller {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.button-controller label {
  cursor: pointer;
}
.button-controller input[type=radio], .button-controller input[type=checkbox] {
  appearance: none;
  border: 1px solid #6F6F72;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.625rem;
  cursor: pointer;
}
.button-controller input[type=radio][data-icon=text], .button-controller input[type=checkbox][data-icon=text] {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}
.button-controller input[type=radio][data-icon=text]::after, .button-controller input[type=checkbox][data-icon=text]::after {
  content: attr(data-icon-text);
}
.button-controller:not(.no-icon) input[type=radio], .button-controller:not(.no-icon) input[type=checkbox] {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 70%, contain;
  background-color: #fff;
}
.button-controller input[type=text] {
  appearance: none;
  border: 1px solid #6F6F72;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.625rem;
  cursor: pointer;
}
.button-controller.no-icon {
  position: relative;
  justify-content: center;
}
.button-controller.no-icon label {
  position: absolute;
  font-weight: 600;
}

.timesetting-container .button-triangle {
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;
  opacity: 0.5;
  border: 1rem solid transparent;
  border-radius: 0.25rem;
  padding: 0;
}
.timesetting-container .button-triangle:hover, .timesetting-container .button-triangle:focus, .timesetting-container .button-triangle:focus-visible {
  opacity: 1;
  outline: none;
}
.timesetting-container input[type=text] {
  padding: 0.5rem;
  text-align: center;
  font-weight: 600;
}
.timesetting-container input[type=text]:focus-visible {
  outline-color: #a9a9a9;
}

.btn-default {
  padding: 0.5rem 1rem;
  border-radius: 1rem;
  font-size: 1rem;
}

@keyframes flying {
  from {
    transform: translate(0, 0) rotate(0) scale(1.3);
  }
  to {
    transform: translate(3px, -3px) rotate3d(1, 1, 1, 30deg) scale(0.8);
  }
}
@keyframes to-left-center {
  from {
    transform: translateX(-3rem);
  }
  to {
    transform: translateX(0px);
  }
}
@keyframes to-right-center {
  from {
    transform: translateX(3rem);
  }
  to {
    transform: translateX(0px);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/css/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EAGO,gBAAgB;EACrB,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EAGO,gBAAgB;EACrB,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,+CAA+C;EACjD;EACA;IACE,mEAAmE;EACrE;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".controller-header .btn-send {\r\n  background: none;\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  font-weight: 600;\r\n  padding: 0.5rem 0;\r\n  margin-left: auto;\r\n}\r\n.controller-header .btn-send img, .controller-header .btn-send svg {\r\n  width: 1rem;\r\n  height: 1rem;\r\n}\r\n.controller-header .btn-send:not(:disabled):hover img, .controller-header .btn-send:not(:disabled):hover svg {\r\n  transition: all 1s ease-in-out;\r\n  animation: flying linear 1s infinite normal;\r\n  cursor: pointer;\r\n}\r\n\r\n.button-controller {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n.button-controller label {\r\n  cursor: pointer;\r\n}\r\n.button-controller input[type=radio], .button-controller input[type=checkbox] {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n       appearance: none;\r\n  border: 1px solid #6F6F72;\r\n  width: 2.5rem;\r\n  height: 2.5rem;\r\n  border-radius: 0.625rem;\r\n  cursor: pointer;\r\n}\r\n.button-controller input[type=radio][data-icon=text], .button-controller input[type=checkbox][data-icon=text] {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: 600;\r\n}\r\n.button-controller input[type=radio][data-icon=text]::after, .button-controller input[type=checkbox][data-icon=text]::after {\r\n  content: attr(data-icon-text);\r\n}\r\n.button-controller:not(.no-icon) input[type=radio], .button-controller:not(.no-icon) input[type=checkbox] {\r\n  background-position: center center;\r\n  background-repeat: no-repeat;\r\n  background-size: 70%, contain;\r\n  background-color: #fff;\r\n}\r\n.button-controller input[type=text] {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n       appearance: none;\r\n  border: 1px solid #6F6F72;\r\n  width: 2.5rem;\r\n  height: 2.5rem;\r\n  border-radius: 0.625rem;\r\n  cursor: pointer;\r\n}\r\n.button-controller.no-icon {\r\n  position: relative;\r\n  justify-content: center;\r\n}\r\n.button-controller.no-icon label {\r\n  position: absolute;\r\n  font-weight: 600;\r\n}\r\n\r\n.timesetting-container .button-triangle {\r\n  display: inline-block;\r\n  width: 1.5rem;\r\n  height: 1.5rem;\r\n  opacity: 0.5;\r\n  border: 1rem solid transparent;\r\n  border-radius: 0.25rem;\r\n  padding: 0;\r\n}\r\n.timesetting-container .button-triangle:hover, .timesetting-container .button-triangle:focus, .timesetting-container .button-triangle:focus-visible {\r\n  opacity: 1;\r\n  outline: none;\r\n}\r\n.timesetting-container input[type=text] {\r\n  padding: 0.5rem;\r\n  text-align: center;\r\n  font-weight: 600;\r\n}\r\n.timesetting-container input[type=text]:focus-visible {\r\n  outline-color: #a9a9a9;\r\n}\r\n\r\n.btn-default {\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 1rem;\r\n  font-size: 1rem;\r\n}\r\n\r\n@keyframes flying {\r\n  from {\r\n    transform: translate(0, 0) rotate(0) scale(1.3);\r\n  }\r\n  to {\r\n    transform: translate(3px, -3px) rotate3d(1, 1, 1, 30deg) scale(0.8);\r\n  }\r\n}\r\n@keyframes to-left-center {\r\n  from {\r\n    transform: translateX(-3rem);\r\n  }\r\n  to {\r\n    transform: translateX(0px);\r\n  }\r\n}\r\n@keyframes to-right-center {\r\n  from {\r\n    transform: translateX(3rem);\r\n  }\r\n  to {\r\n    transform: translateX(0px);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
